import { getLocale } from "./locale";

export function handleDescriptionLocale(param) {
  let labelDescription = "";

  switch (getLocale()) {
    case "it":
      labelDescription = param.descriptionItalian
        ? param.descriptionItalian
        : param.description;
      break;
    case "es":
      labelDescription = param.descriptionSpanish
        ? param.descriptionSpanish
        : param.description;
      break;
    case "pt":
      labelDescription = param.descriptionPortuguese
        ? param.descriptionPortuguese
        : param.description;
      break;
    case "en":
      labelDescription = param.descriptionEnglish
        ? param.descriptionEnglish
        : param.description;
      break;
    default:
      break;
  }

  return labelDescription;
}
